import { z } from "../wire/zod";

export const noDataSchema = z.record(z.string(), z.never());
